import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { FeedbackQuestionsFragmentDoc, FeedbackQuestionFragmentDoc } from '../../../../feedback/graphql/fragments/generated/FeedbackQuestions';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FeedbackQuestionsQueryVariables = Types.Exact<{
  filters: Types.FeedbackQuestionFilter;
}>;


export type FeedbackQuestionsQuery = { feedbackQuestions?: Array<{ id: string, type: Types.FeedbackQuestionTypeEnum, questions: Array<{ id: string, description?: string | null, questionText?: string | null, questionType: Types.QuestionTypeEnum, settings?: { ratingScale?: number | null } | null }> }> | null };


export const FeedbackQuestionsDocument = /*#__PURE__*/ gql`
    query feedbackQuestions($filters: FeedbackQuestionFilter!) {
  feedbackQuestions(filters: $filters) {
    ...FeedbackQuestions
  }
}
    ${FeedbackQuestionsFragmentDoc}
${FeedbackQuestionFragmentDoc}`;

export function useFeedbackQuestionsQuery(options: Omit<Urql.UseQueryArgs<FeedbackQuestionsQueryVariables>, 'query'>) {
  return Urql.useQuery<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>({ query: FeedbackQuestionsDocument, ...options });
};